import { apiRoutes } from "routes";
import FetchHelpers from "utils/FetchHelpers";

export default {
  index() {
    const url = apiRoutes.offerGroupsPath(1);
    return FetchHelpers.get(url);
  },
};
